import {
  Box,
  Button,
  Container,
  Stack,
  Typography,
  Paper,
} from "@mui/material";
import bgimaeg from "../../assets/images/costcardIcon-bg.png";

export function FinalCTA() {
 const talkToExpert = () => {
   const phone = "919532119007"; // no + sign
   const message = "Hello Costlix, I want to talk to an cost expert.";
   const encodedMessage = encodeURIComponent(message);

   window.open(`https://wa.me/${phone}?text=${encodedMessage}`, "_blank");
 };


  const scrollToEstimator = () => {
    document
      .getElementById("estimator")
      ?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 7, md: 12 },
        backgroundColor: "var( --color-fiery)",
      }}
    >
      <Container maxWidth="md">
        <Paper
          elevation={0}
          sx={{
            position: "relative",
            overflow: "hidden",
            p: { xs: 3.5, sm: 4.5, md: 6 },
            borderRadius: 4,
            textAlign: "center",
            border: "1px solid var(--color-midnight-15)",
            boxShadow: "0 30px 80px rgba(15,58,66,0.12)",

            /* 🔥 Premium layered background */
            backgroundImage: `
              linear-gradient(
                180deg,
                rgba(255,255,255,0.95) 0%,
                rgba(246,247,235,0.9) 60%,
                rgba(233,79,55,0.08) 100%
              ),
              url(${bgimaeg})
            `,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {/* Soft fiery glow */}
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              pointerEvents: "none",
              background:
                "radial-gradient(circle at 50% 120%, rgba(233,79,55,0.25), transparent 60%)",
            }}
          />

          {/* Content */}
          <Box position="relative">
            <Typography
              sx={{
                fontSize: { xs: "0.65rem", md: "0.75rem" },
                fontWeight: 700,
                letterSpacing: "0.18em",
                textTransform: "uppercase",
                color: "var(--color-midnight-70)",
                mb: 1,
              }}
            >
              Ready to plan with confidence?
            </Typography>

            <Typography
              sx={{
                fontSize: { xs: "1.35rem", sm: "1.7rem", md: "2.2rem" },
                fontWeight: 800,
                lineHeight: 1.25,
                mb: 1.6,
                color: "var(--color-midnight)",
              }}
            >
              Get a clear project cost —{" "}
              <Box component="span" sx={{ color: "var(--color-fiery)" }}>
                before you invest.
              </Box>
            </Typography>

            <Typography
              sx={{
                maxWidth: 560,
                mx: "auto",
                fontSize: { xs: "0.85rem", md: "1rem" },
                lineHeight: 1.7,
                color: "var(--color-midnight-70)",
                mb: { xs: 3, md: 4 },
              }}
            >
              Answer a few guided questions and receive a realistic,
              benchmark-based cost estimate tailored to your project.
            </Typography>

            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={2}
              justifyContent="center"
            >
              <Button
                onClick={scrollToEstimator}
                variant="contained"
                size="large"
                sx={{
                  px: 4,
                  py: 1.4,
                  fontWeight: 700,
                  backgroundColor: "var(--color-fiery)",
                  boxShadow: "0 14px 32px rgba(233,79,55,0.35)",

                  "&:hover": {
                    backgroundColor: "var(--color-fiery-hover)",
                    boxShadow: "0 18px 40px rgba(233,79,55,0.45)",
                  },
                }}
              >
                Get Cost Estimate
              </Button>

              <Button
                onClick={() => talkToExpert()}
                variant="outlined"
                size="large"
                sx={{
                  px: 4,
                  py: 1.4,
                  fontWeight: 600,
                  borderColor: "var(--color-midnight-15)",
                  color: "var(--color-midnight)",

                  "&:hover": {
                    borderColor: "var(--color-fiery)",
                    color: "var(--color-fiery)",
                  },
                }}
              >
                Talk to an Expert
              </Button>
            </Stack>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}
